var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('b-col',[_c('input-select-search',{attrs:{"label":"Clique abaixo para selecionar um aluno ou sua matrícula:","options":_vm.opcoes.matricula,"placeholder":"Digite ou procure"},model:{value:(_vm.matriculaSelecionada),callback:function ($$v) {_vm.matriculaSelecionada=$$v},expression:"matriculaSelecionada"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }